import React from "react";
import { Link } from "react-router-dom";
import iconeImg from "../../assets/img/icone.png";

const GOLD = "#E5A325";
const BG = "#0f1117";
const CARD_BG = "rgba(20,22,30,0.85)";
const BORDER = "rgba(255,255,255,0.08)";
const TEXT = "#e4e4e7";
const TEXT_DIM = "rgba(255,255,255,0.55)";
const GRADIENT = "linear-gradient(135deg, hsl(43,96%,56%) 0%, hsl(38,100%,50%) 100%)";

const Unauthorized = () => {
    document.title = "Não Autorizado | Oplena";

    return (
        <div style={{
            position: "fixed", inset: 0, background: BG,
            display: "flex", alignItems: "center", justifyContent: "center",
            padding: 24, overflow: "hidden",
            fontFamily: "'Space Grotesk','Inter',system-ui,sans-serif",
        }}>
            {/* Ambient glow */}
            <div style={{
                position: "absolute", top: "-20%", left: "50%", transform: "translateX(-50%)",
                width: 600, height: 600, borderRadius: "50%",
                background: "radial-gradient(circle, rgba(229,163,37,0.18), transparent 70%)",
                pointerEvents: "none", filter: "blur(40px)",
            }} />
            <div style={{
                position: "absolute", bottom: "-30%", right: "-10%",
                width: 500, height: 500, borderRadius: "50%",
                background: "radial-gradient(circle, rgba(229,163,37,0.08), transparent 70%)",
                pointerEvents: "none", filter: "blur(60px)",
            }} />

            {/* Card */}
            <div style={{
                position: "relative", zIndex: 1,
                background: CARD_BG, backdropFilter: "blur(24px)", WebkitBackdropFilter: "blur(24px)",
                border: `1px solid ${BORDER}`, borderRadius: 24,
                padding: "48px 40px", maxWidth: 480, width: "100%",
                textAlign: "center",
                boxShadow: "0 20px 60px rgba(0,0,0,0.5), inset 0 1px 0 rgba(255,255,255,0.05)",
            }}>
                <div style={{
                    width: 80, height: 80, margin: "0 auto 24px",
                    borderRadius: 20, background: "rgba(229,163,37,0.12)",
                    border: `1px solid rgba(229,163,37,0.25)`,
                    display: "flex", alignItems: "center", justifyContent: "center",
                    position: "relative",
                }}>
                    <img src={iconeImg} alt="Oplena" width={48} height={48} style={{ objectFit: "contain" }} />
                    <div style={{
                        position: "absolute", top: -6, right: -6,
                        width: 28, height: 28, borderRadius: "50%",
                        background: BG, border: `2px solid ${GOLD}`,
                        display: "flex", alignItems: "center", justifyContent: "center",
                        color: GOLD, fontSize: 14,
                    }}>
                        <i className="fa-solid fa-lock" />
                    </div>
                </div>

                <div style={{
                    display: "inline-block", padding: "4px 12px", borderRadius: 999,
                    background: "rgba(229,163,37,0.12)", border: "1px solid rgba(229,163,37,0.25)",
                    color: GOLD, fontSize: 11, fontWeight: 700, letterSpacing: "0.08em",
                    textTransform: "uppercase", marginBottom: 16,
                }}>
                    Erro 403 · Acesso restrito
                </div>

                <h1 style={{
                    color: TEXT, fontSize: "1.75rem", fontWeight: 700, marginBottom: 12,
                    letterSpacing: "-0.02em",
                }}>
                    Você não tem permissão
                </h1>

                <p style={{
                    color: TEXT_DIM, fontSize: 14, lineHeight: 1.6, marginBottom: 32,
                }}>
                    Esta página é restrita ao seu perfil de acesso. Se acredita que isto é um engano,
                    entre em contato com o suporte da Oplena.
                </p>

                <div style={{ display: "flex", gap: 12, justifyContent: "center", flexWrap: "wrap" }}>
                    <Link
                        to="/admin"
                        style={{
                            background: GRADIENT, color: BG,
                            padding: "12px 24px", borderRadius: 12,
                            fontWeight: 600, fontSize: 14, textDecoration: "none",
                            display: "inline-flex", alignItems: "center", gap: 8,
                            boxShadow: "0 4px 14px rgba(229,163,37,0.3)",
                            transition: "transform 0.15s ease, box-shadow 0.15s ease",
                        }}
                        onMouseEnter={e => { e.currentTarget.style.transform = "translateY(-1px)"; e.currentTarget.style.boxShadow = "0 6px 18px rgba(229,163,37,0.4)"; }}
                        onMouseLeave={e => { e.currentTarget.style.transform = "translateY(0)"; e.currentTarget.style.boxShadow = "0 4px 14px rgba(229,163,37,0.3)"; }}
                    >
                        <i className="fa-solid fa-arrow-left" /> Voltar para o início
                    </Link>
                    <a
                        href="mailto:suporte@oplena.com.br"
                        style={{
                            background: "transparent", color: TEXT,
                            border: `1px solid ${BORDER}`,
                            padding: "12px 24px", borderRadius: 12,
                            fontWeight: 600, fontSize: 14, textDecoration: "none",
                            display: "inline-flex", alignItems: "center", gap: 8,
                            transition: "background 0.15s ease",
                        }}
                        onMouseEnter={e => { e.currentTarget.style.background = "rgba(255,255,255,0.04)"; }}
                        onMouseLeave={e => { e.currentTarget.style.background = "transparent"; }}
                    >
                        <i className="fa-solid fa-headset" /> Falar com suporte
                    </a>
                </div>
            </div>
        </div>
    );
};

export default Unauthorized;
